// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Api from "../../../../core/Api.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Crm from "../../../../models/Crm.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Form from "../../../../core/Form.js";
import * as Buhta_cabinet__ItemFormConstructor from "../../../molecules/ItemFormConstructor.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Request from "../../../../core/Request.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Select from "../../../html/Select.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

function CredentialCreate(Props) {
  const match = Buhta_core__Tenant.useTenant(undefined);
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const partial_arg = match[0];
  const form = Buhta_cabinet__Form.useForm(function (param) {
        return Buhta_cabinet__Keychain.CredentialService.create(partial_arg, param);
      });
  const orgField = Buhta_cabinet__Form.useField(form, undefined, undefined, (function (value) {
          if (Belt__Belt_Option.isSome(value)) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          } else {
            return {
                    TAG: /* Error */1,
                    _0: "выберите предприятие"
                  };
          }
        }));
  const nameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const usernameField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const passwordField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          if (value.length > 5) {
            return {
                    TAG: /* Ok */0,
                    _0: value
                  };
          } else {
            return {
                    TAG: /* Error */1,
                    _0: "Пароль должен содержать больше 5 символов"
                  };
          }
        }));
  const memoField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const websiteField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const tagField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const expireDateField = Buhta_cabinet__Form.useField(form, "", undefined, (function (value) {
          return {
                  TAG: /* Ok */0,
                  _0: value
                };
        }));
  const onSubmit = function (param) {
    const match = Curry._1(form.validate, undefined);
    const match$1 = orgField.value;
    if (match && match$1 !== undefined) {
      const fieldsToForm_name = nameField.value;
      const fieldsToForm_username = usernameField.value;
      const fieldsToForm_password = passwordField.value;
      const fieldsToForm_website = websiteField.value;
      const fieldsToForm_memo = memoField.value;
      const fieldsToForm_tag = tagField.value;
      const fieldsToForm_expire_date = expireDateField.value;
      const fieldsToForm = {
        name: fieldsToForm_name,
        username: fieldsToForm_username,
        password: fieldsToForm_password,
        website: fieldsToForm_website,
        memo: fieldsToForm_memo,
        tag: fieldsToForm_tag,
        expire_date: fieldsToForm_expire_date
      };
      const __x = Curry._1(form.submit, Buhta_cabinet__Keychain.CredentialForm.toCreateRequest(match$1.value, fieldsToForm));
      return $$Promise.get(__x, (function (result) {
                    if (result.TAG !== /* Ok */0) {
                      return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                    }
                    Buhta_cabinet__Route.navigateTo({
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Keychain */0,
                            _0: {
                              TAG: /* Credentials */1,
                              _0: {
                                TAG: /* View */0,
                                _0: result._0.id
                              }
                            }
                          }
                        });
                    Curry._1(dispatchToasts, {
                          TAG: /* Add */0,
                          _0: {
                            id: Buhta_core__Toast.generateId(undefined),
                            text: "Учетные данные успешно созданы",
                            kind: "success",
                            onClick: (function (param) {
                                
                              })
                          }
                        });
                  }));
    }
    Curry._1(dispatchToasts, {
          TAG: /* Add */0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Проверьте введенные данные",
            kind: "warning",
            onClick: (function (param) {
                
              })
          }
        });
  };
  const arg = Buhta_cabinet__Crm.Org.grid;
  const arg$1 = Curry._2(Buhta_cabinet__Api.Endpoints.Crm.orgs, undefined, undefined);
  const text = orgField.valueForDisplay;
  let tmp;
  tmp = text.TAG === /* Ok */0 ? null : JsxRuntime.jsx("p", {
          children: text._0,
          className: "mt-1 text-red-500 text-sm"
        });
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                    title: "",
                    leftActions: {
                      hd: JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx(CloseSvg, {}),
                            onClick: (function (param) {
                                Buhta_cabinet__Route.navigateTo({
                                      TAG: /* Admin */7,
                                      _0: {
                                        TAG: /* Keychain */0,
                                        _0: {
                                          TAG: /* Credentials */1,
                                          _0: /* List */0
                                        }
                                      }
                                    });
                              })
                          }),
                      tl: /* [] */0
                    },
                    rightActions: {
                      hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                            size: "s",
                            kind: "default",
                            onClick: (function (param) {
                                Buhta_cabinet__Route.navigateTo({
                                      TAG: /* Admin */7,
                                      _0: {
                                        TAG: /* Keychain */0,
                                        _0: {
                                          TAG: /* Credentials */1,
                                          _0: /* List */0
                                        }
                                      }
                                    });
                              }),
                            children: "Отмена"
                          }),
                      tl: {
                        hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                              size: "s",
                              kind: "primary",
                              state: form.isSubmitting ? "Loading" : "Default",
                              type_: "submit",
                              disabled: form.isSubmitting,
                              onClick: (function (param) {
                                  
                                }),
                              children: "Создать"
                            }),
                        tl: /* [] */0
                      }
                    },
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                  className: "mb-6 text-default-gray",
                                  children: "Новые данные"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Предприятие",
                                          value: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_cabinet__Select.Searchable.make, {
                                                        label: "Предприятие",
                                                        useFetch: (function (param) {
                                                            const func = function (param$1, param$2, param$3) {
                                                              return Buhta_cabinet__Request.useGrid(param, arg$1, param$1, param$2, param$3);
                                                            };
                                                            return function (param) {
                                                              return Curry._2(func, param, arg);
                                                            };
                                                          }),
                                                        mapper: (function (item) {
                                                            return {
                                                                    value: item.id,
                                                                    text: item.name
                                                                  };
                                                          }),
                                                        size: "m",
                                                        selectedOption: orgField.value,
                                                        onChange: orgField.onChange,
                                                        labelFloating: false
                                                      }),
                                                  tmp
                                                ],
                                                className: "-mt-2 sm:m-0"
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Название",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "Введите название",
                                                size: "s",
                                                onChange: nameField.onChange,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: nameField.valueForDisplay,
                                                value: nameField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Логин",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "Введите логин пользователя",
                                                size: "s",
                                                onChange: usernameField.onChange,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: usernameField.valueForDisplay,
                                                value: usernameField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Пароль",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "Введите пароль",
                                                size: "s",
                                                onChange: passwordField.onChange,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: passwordField.valueForDisplay,
                                                value: passwordField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Пометка",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "пометка",
                                                size: "s",
                                                onChange: memoField.onChange,
                                                multiline: true,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: memoField.valueForDisplay,
                                                value: memoField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Сайт",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "Введите сайт",
                                                size: "s",
                                                onChange: websiteField.onChange,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: websiteField.valueForDisplay,
                                                value: websiteField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Тэг",
                                          value: JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                placeholder: "Введите тэг",
                                                size: "s",
                                                onChange: tagField.onChange,
                                                className: "-mt-2 sm:m-0",
                                                validatedValue: tagField.valueForDisplay,
                                                value: tagField.value
                                              }),
                                          size: "medium"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__ItemFormConstructor.SectionItem.make, {
                                          name: "Истекает в",
                                          value: JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                      value: expireDateField.value,
                                                      onPicked: (function (date) {
                                                          Curry._1(expireDateField.onChange, DateTime.toDateFormat(date));
                                                        })
                                                    }),
                                                className: "sm:mt-2"
                                              }),
                                          size: "medium"
                                        })
                                  ],
                                  className: "flex flex-col space-y-2 sm:grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-12 sm:items-center gap-x-4"
                                })
                          ],
                          className: "p-6"
                        })
                  }),
              className: "flex-1",
              onSubmit: (function (ev) {
                  onSubmit(undefined);
                  ev.preventDefault();
                })
            });
}

const make = CredentialCreate;

export {
  make ,
}
/* Buhta_cabinet__Button Not a pure module */
